import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

export const USER_SUMMARY_FIELDS_FRAGMENT: DocumentNode = gql`
  fragment UserSummaryFields on UserNode {
    id
    name
    handle
    avatarUrl
    email
    suspended
    lastSeen
    joinedOn
    passwordLastChangedAt
    tenantCollaborations {
      id
      party {
        ... on PartyInterface {
          id
          name
        }
      }
      policy {
        id
        name
      }
    }
  }
`;
